import req from 'shared/req';
import {FormFieldError} from 'src/utils/errors/FormFieldError';

export interface AdminUniversity {
  join_page_slug: string | null;
  listing: {
    _id: string;
    slug: string;
    name: string;
  };
  university: {
    enableReportIntegrations: boolean;
  };
}

export default class AdminUniversityService {
  static async show(id: string) {
    let response;
    try {
      response = await req<AdminUniversity>({
        url: `/v1/admin/university/${id}`,
      });
    } catch (error) {
      throw new FormFieldError(error);
    }

    return response;
  }

  static async new(slug: string) {
    let response;
    try {
      response = await req({
        url: `/v1/admin/university/new?slug=${slug}`,
      });
    } catch (error) {
      throw new FormFieldError(error);
    }

    return response;
  }
}
